import * as React from 'react';

const SvgWechat = (props) => (
  <svg
    width={50}
    height={40}
    className="fill-current text-black dark:text-white"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#wechat_svg__a)">
      <path d="M50 25.962C50 19.099 43.281 13.5 35.008 13.5s-14.946 5.598-14.946 12.46c0 6.864 6.72 12.462 14.992 12.462 1.6 0 3.108-.18 4.525-.587.412-.09.868-.045 1.28.136l3.702 1.986c.228.137.548-.09.456-.361l-.732-2.935c-.092-.45.046-.903.456-1.173C47.944 33.186 50 29.799 50 25.962Zm-20.338-1.625a2.036 2.036 0 0 1-2.057-2.03c0-1.13.914-2.032 2.056-2.032 1.143 0 2.057.903 2.057 2.031a2.036 2.036 0 0 1-2.056 2.031Zm10.1 0a2.036 2.036 0 0 1-2.056-2.03c0-1.13.915-2.032 2.057-2.032s2.056.903 2.056 2.031c0 1.128-.96 2.031-2.056 2.031Z" />
      <path d="M18.83 26.007c0-7.63 7.313-13.817 16.362-13.817h.686C34.414 5.282 27.011 0 18.098 0 8.09 0 0 6.592 0 14.765c0 4.516 2.514 8.578 6.445 11.288.274.18.366.496.32.812l-1.37 4.786c-.092.316.274.632.594.45l5.346-3.16c.366-.224.776-.27 1.188-.136 1.783.451 3.657.724 5.577.724.412 0 .822 0 1.28-.046a11.21 11.21 0 0 1-.55-3.476Zm5.347-18.196c1.326 0 2.422 1.083 2.422 2.393 0 1.31-1.096 2.394-2.422 2.394s-2.422-1.083-2.422-2.394c0-1.31 1.098-2.393 2.422-2.393ZM12.02 12.598c-1.327 0-2.423-1.083-2.423-2.394 0-1.31 1.096-2.393 2.423-2.393 1.326 0 2.422 1.083 2.422 2.393 0 1.31-1.05 2.394-2.422 2.394Z" />
    </g>
    <defs>
      <clipPath id="wechat_svg__a">
        <path d="M0 0h50v40H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgWechat;
